// @module Eureka.MaxaPriceMatch.MaxaRequestReturn.View
define('Eureka.MaxaPriceMatch.MaxaRequestReturn.View'
    , [
        'eureka_maxapricematch_maxarequestreturn.tpl'

        , 'Eureka.MaxaPriceMatch.MaxaPriceMatch.SS2Model'
        , 'Profile.Model'

        , 'Backbone'
    ]
    , function (
        eureka_maxapricematch_maxarequestreturn_tpl
        , MaxaPriceMatchSS2Model
        , ProfileModel
        , Backbone
    ) {
        'use strict';

        // @class Eureka.MaxaPriceMatch.MaxaPriceMatch.View @extends Backbone.View
        return Backbone.View.extend({

            template: eureka_maxapricematch_maxarequestreturn_tpl

            , initialize: function (options) {
                this.profile = ProfileModel.getInstance()
                console.log("this.profile", this.profile)
                this.isLoggedIn = this.profile.attributes.isLoggedIn
                console.log("this.isLoggedIn", this.isLoggedIn)
                this.selectedFiles = [];
            }

            , events: {
                'click [data-action="submitButton"]': 'submitForm'
            }

            , bindings: {}

            , childViews: {}

            , validationSchema: {
                reason: function (value) {
                    return /^[a-zA-Z0-9\s]+$/.test(value)
                },
                name: function (value) {
                    return /^[a-zA-Z0-9\s]+$/.test(value)
                },
                phone: function (value) {
                    return /^\+?(\d{1,4})?[-.\s]?(\(?\d{1,4}\)?)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/.test(value)
                },
                orderRef: function (value) {
                    return /^[a-zA-Z0-9\s]+$/.test(value)
                },
                returnSku: function (value) {
                    return /^[a-zA-Z0-9.]+$/.test(value)
                },
                quantity: function (value) {
                    return /^\d+$/.test(value)
                },
                email: function (value) {
                    // Email validation (basic RFC 5322 compliant)
                    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
                }
            }

            , errorList: {
                "reason": { error: 'reasonError', input: 'returnReason' },
                "name": { error: 'nameError', input: 'returnName' },
                "phone": { error: 'phoneError', input: 'returnPhone' },
                "orderRef": { error: 'orderError', input: 'returnOrderRef' },
                "returnSku": { error: 'returnSkuError', input: 'returnSKU' },
                "quantity": { error: 'quantityError', input: 'returnQty' },
                "email": { error: 'emailError', input: 'returnEmail' }
            }

            , submitForm: function submitForm() {


                Object.entries(this.errorList).forEach(([key, value]) => {
                    let element = document.getElementById(value.error)
                    console.log({ element: element, value: value, key: key, list: this.errorList })
                    element.style.display = 'none'
                    let input = document.getElementById(value.input)
                    input.style.border = "2px solid black"
                });

                let model = new MaxaPriceMatchSS2Model();
                let data = {
                    isReturn: true,
                    reason: document.getElementById('returnReason').value,
                    name: document.getElementById('returnName').value,
                    phone: document.getElementById('returnPhone').value,
                    orderRef: document.getElementById('returnOrderRef').value,
                    returnSku: document.getElementById('returnSKU').value,
                    quantity: document.getElementById('returnQty').value,
                    email: document.getElementById('returnEmail').value
                }
                let isValid = this.validate(data, this.validationSchema)
                if (isValid.length === 0) {
                    model.fetch({ type: "post", data: data }).done(function (result) {
                        if (result.success) {
                            window.location = "https://" + SC.ENVIRONMENT.shoppingDomain
                        }
                    });
                } else {
                    console.log({ isValid })
                    for (let i = 0; i < isValid.length; i++) {
                        let element = document.getElementById(this.errorList[isValid[i].message].error)
                        element.style.display = "block"
                        let input = document.getElementById(this.errorList[isValid[i].message].input)
                        input.style.border = "2px solid red"
                    }

                }
            }

            , validate: function (data, schema) {
                return Object.keys(schema).map(function (property) {
                    var validator = schema[property];

                    return [property, !validator.required || (property in data), validator(data[property])];
                }).filter(function (entry) {
                    return !entry[1] || !entry[2];
                }).map(function (entry) {
                    if (!entry[1]) return new Error(entry[0]);
                    else return new Error(entry[0]);
                });
            }

            //@method getContext @return Eureka.MaxaPriceMatch.MaxaPriceMatch.View.Context
            , getContext: function getContext() {
                //@class Eureka.MaxaPriceMatch.MaxaPriceMatch.View.Context
                this.message = this.message || 'Hello World!!'
                return {
                    message: this.message
                };
            }
        });
    });
